<template>
  <div class="room-content">
    <Navbar :appTitle="appTitle" @ClickRight="$router.push('/application')" />

    <Search
      ref="topSearch"
      class="search topSearchPading"
      placeholder="项目名称|关联订单|工单编号|物品名称"
      :isAdd="false"
      :isScreen="true"
      :isType="true"
      @onSearch="onSearch"
      @onScreen="onScreen"
    >
    </Search>

    <div class="search-top-flex">
      <!-- 状态 -->
      <van-dropdown-menu active-color="#1989fa" class="search-top-flex-item-width1">
        <van-dropdown-checkbox
          title="状态"
          :key="selecTwoKey"
          :selectValue="selectTwoValue"
          :columns="messSingleProcessTaskStaticsDtoList"
          @comfirm="typeChange('selectTwoValue', 'orderStatuss', $event)"
        >
        </van-dropdown-checkbox>
      </van-dropdown-menu>

      <van-dropdown-menu active-color="#1989fa" class="search-top-flex-item-width2">
        <van-dropdown-item title="计划开始时间" @open="createdTimeBeginVisible = true" />
      </van-dropdown-menu>

      <van-dropdown-menu active-color="#1989fa" class="search-top-flex-item-width2">
        <van-dropdown-item title="计划结束时间" @open="createdTimeBeginVisible2 = true" />
      </van-dropdown-menu>
    </div>

    <search-tag ref="SearchTag" @getCategory="getCategory"></search-tag>
    <!--分页列表 -->
    <div
      class="listBox"
      :class="{
        currentEnvironmentTrue: GLOBAL.currentEnvironment,
        currentEnvironmentFalse: !GLOBAL.currentEnvironment,
      }"
    >
      <pageList
        ref="pageList"
        :checkedShow="checkedShow"
        :operationTxt="operationTxt"
        :columns="columns"
        :listUrl="listUrl"
        :minLen="3"
        :usedGetMethods="false"
      >
        <div slot="head" slot-scope="{ item }" class="head-slot-class">
          <div class="head-slot-div">
            <div class="icon"></div>
            <div class="title">
              {{ item.orderCode }}
            </div>
          </div>
        </div>

        <div class="rt-column" slot="body" slot-scope="{ item }">
          <div class="rt-row">
            <div class="column">
              <span class="column-t">生产物品：</span>
              <span class="column-c">{{ item.serialName || "-" }} | {{ item.serialSpecifications || "-" }}</span>
            </div>
          </div>

          <div class="rt-row">
            <div class="column">
              <span class="column-t">计划时间：</span>
              <span class="column-c">{{ item.timePeriod || "-" }}</span>
            </div>
          </div>

          <div class="rt-row">
            <div class="column">
              <span class="column-t">计划生产数量：</span>
              <span class="column-c">{{ item.planProduceNum || 0 }}</span>
            </div>
          </div>

          <div class="rt-row">
            <div class="column">
              <span class="column-t">项目名称：</span>
              <span
                class="column-c"
                :style="{ color: item.projectName !== null ? '#2B85E4' : '' }"
                @click="goProjectOrder(item)"
                >{{ item.projectName || "-" }}</span
              >
              <span v-if="item.projectName" style="color: #2B85E4;" @click="goProjectOrder(item)"> > </span>
            </div>
          </div>

          <div class="rt-row">
            <div class="column">
              <span class="column-t">关联订单：</span>
              <span class="column-c">{{ item.sellOrderCode || "-" }}</span>
            </div>
          </div>
        </div>

        <div slot="label" slot-scope="{ item }" class="labelBox">
          <div class="allLeft">
            <div
              class="labelLeft"
              :style="{
                color: orderStatusFn(item.orderStatus).color,
                backgroundColor: orderStatusFn(item.orderStatus).bcColor,
              }"
            >
              {{ item.orderStatusText }}
            </div>

            <div
              class="labelLeft"
              v-if="item.urgency"
              :style="{
                color: urgencyStatusFn(item.urgency).color,
                backgroundColor: urgencyStatusFn(item.urgency).bgColor,
              }"
            >
              {{ item.urgencyText }}
            </div>
          </div>
          <div class="allRight" @click="showUrgencyChoose(item)">
            编排
          </div>
        </div>
      </pageList>
    </div>

    <!--任务开始 => 开始时间 -->
    <van-popup v-model="createdTimeBeginVisible" position="bottom">
      <van-datetime-picker
        @confirm="confirmCreatedStartTime"
        @cancel="cancelCreatedStartTime"
        type="date"
        title="开始时间"
        v-model="minDate"
      />
    </van-popup>

    <!--任务开始 => 结束时间 -->
    <van-popup v-model="createdTimeEndVisible" position="bottom">
      <van-datetime-picker
        @confirm="confirmCreatedEndTime"
        @cancel="cancelCreatedEndTime"
        type="date"
        title="结束时间"
        :min-date="createEndMinDate"
      />
    </van-popup>

    <!--任务结束 => 开始时间 -->
    <van-popup v-model="createdTimeBeginVisible2" position="bottom">
      <van-datetime-picker
        @confirm="confirmCreatedStartTime2"
        @cancel="cancelCreatedStartTime2"
        type="date"
        title="开始时间"
        v-model="minDate2"
      />
    </van-popup>

    <!--任务结束 => 结束时间 -->
    <van-popup v-model="createdTimeEndVisible2" position="bottom">
      <van-datetime-picker
        @confirm="confirmCreatedEndTime2"
        @cancel="cancelCreatedEndTime2"
        type="date"
        title="结束时间"
        :min-date="createEndMinDate2"
      />
    </van-popup>
    <van-dialog
      @confirm="updateUrgencyChoose"
      v-model="urgencyChoose.showUrgencyChooseFlag"
      title="编排紧急状态"
      show-cancel-button
    >
      <div class="radioBox" style="margin:20px 0px;display: flex;justify-content: center;">
        <van-radio-group v-model="urgencyChoose.chooseType" direction="horizontal">
          <van-radio name="0">非常紧急</van-radio>
          <van-radio name="1">紧急</van-radio>
          <van-radio name="2">正常</van-radio>
        </van-radio-group>
      </div>
    </van-dialog>
    <div class="search-bottoms">
      <!-- <van-button @click="toGscsPage()" block color="#1890ff">
        <div style=" font-weight: 400">工时测算</div>
      </van-button> -->
      <van-button style="margin-left: 10px" @click="toDdpcPage()" block color="#1890ff">
        <div style="color: #fff">
          订单排产
        </div>
      </van-button>
    </div>
  </div>
</template>
<script>
import VanDropdownCheckbox from "@/views/workManagement/defectsDeal/VanDropdownCheckbox"
import Search from "@/components/search"
import SearchTag from "./SearchTag.vue"
import Navbar from "@/components/navBar/navBar_right"
import TabBar from "@/components/TabBar"
import pageList from "@/components/pageList"
import { orderOrchestration } from "@/api/mobile"
import moment from "moment"
import { APILX } from "@/api/requestLx"
import { Dialog } from "vant"
import { hasButton } from "@/utils/hasPermission"

export default {
  name: "productionPlanningList",
  components: {
    Navbar,
    TabBar,
    pageList,
    Search,
    SearchTag,
    VanDropdownCheckbox,
  },
  data() {
    return {
      clickItem: {},
      selectTwoValue: [],
      selecTwoKey: 0,
      valueType: [],
      // 1
      minDate: new Date(),
      createEndMinDate: new Date(),
      createdTimeBeginVisible: false,
      createdTimeEndVisible: false,
      // 2
      minDate2: new Date(),
      createEndMinDate2: new Date(),
      createdTimeBeginVisible2: false,
      createdTimeEndVisible2: false,

      showDialog: false,
      dialogMessage: "",
      checkedShow: false, //列表是否支持选择
      operationTxt: "批量报工", //选择按钮名称
      listUrl: "/produceorder/produceOrderInfo/list", //列表接口
      columns: {
        titleKey: "orderCode", //标题
      },
      keyword: "",
      dropdownObj: {
        orderStatuss: [],
      },
      messSingleProcessTaskStaticsDtoList: [
        {
          text: "未开始",
          value: '0',
          check: false,
        },
        {
          text: "生产中",
          value: '1',
          check: false,
        },
      ],
      reportSelectList: [
        {
          text: "报工状态",
          value: "",
        },
        {
          text: "可报工",
          value: "yes",
        },
        {
          text: "不可报工",
          value: "no",
        },
      ],
      statusList: [
        {
          text: "生产状态",
          value: "",
        },
        {
          text: "未开始",
          value: "notStarted",
        },
        {
          text: "生产中",
          value: "inProduction",
        },
        {
          text: "已作废",
          value: "abolished",
        },
        {
          text: "已完成",
          value: "completed",
        },
      ],
      selectValue: [],
      selecKey: 1,
      appTitle: "",
      currentEnvironment: "",
      urgencyChoose: {
        orderId: "",
        showUrgencyChooseFlag: false,
        chooseType: "",
      },
    }
  },
  methods: {
    // 只在提交时,统一处理格式.
    searchQuery(searchObj) {
      let params = {
        ...searchObj,
        // orderStatuss: searchObj.orderStatuss ? searchObj.orderStatuss.join(",") : "",
        orderStatuss: "0,1",
        orderStatusHide: "0,1",
        urgency: searchObj.urgency ? searchObj.urgency.join(",") : "",
        keyword: this.keyword,
      }
      console.log("searchObj", searchObj)
      this.$refs.pageList.searchQuery(params)
    },
    toGscsPage() {
      this.$router.push({
        path: "/manHourCalculation",
        query: {
          title: "工时计算",
        },
      })
    },
    toDdpcPage() {
      this.$router.push({
        path: "/salesManagement/salesContractList?navTitle=订单排产",
        query: {
          title: "订单排产",
          arrangeFlag: true,
        },
      })
    },
    goProjectOrder(item) {
      let projectName = item.projectName
      if (!projectName) {
        this.$toast("该工单无项目！")
        return
      }
      this.$router.push({
        path: "/workManagement/projectWorkOrder/list?navTitle=项目工单",
        query: { projectName },
      })
    },
    updateUrgencyChoose() {
      // 关闭弹窗
      this.urgencyChoose.showUrgencyChooseFlag = false
      //
      let requestData = {
        id: this.urgencyChoose.orderId,
        urgency: this.urgencyChoose.chooseType,
      }
      orderOrchestration(requestData)
        .then((res) => {
          if (res.code == 200) {
            this.$toast("编排成功")
            // 更新列表
            this.searchQuery(this.dropdownObj)
          } else {
            this.$toast(res.message)
          }
        })
        .catch((e) => {
          this.closeUrgencyChoose()
          console.log("编排请求执行异常！", e)
        })
    },
    showUrgencyChoose(item) {
      this.urgencyChoose.chooseType = item.urgency
      this.urgencyChoose.orderId = item.id
      this.urgencyChoose.showUrgencyChooseFlag = true
    },
    closeUrgencyChoose() {
      this.urgencyChoose.chooseType = ""
      this.urgencyChoose.orderId = ""
      this.urgencyChoose.showUrgencyChooseFlag = false
    },
    hasButton,
    typeChange(v, key, val) {
      switch (key) {
        case "orderStatuss":
          this.dropdownObj.orderStatuss = val.split(",")
          this.$refs.SearchTag.filterForm.orderStatuss = this.dropdownObj.orderStatuss
          break
        default:
          break
      }
      this.dropDownChang()
    },
    open() {
      this.dropdownObj.status = this.valueType.join(",")
      this.$forceUpdate()
    },
    orderStatusFn(v) {
      if (v == 0) {
        return {
          text: "未开始",
          color: "#ff9900",
          bcColor: "#fff5e6",
        }
      } else if (v == 1) {
        return {
          text: "生产中",
          color: "#2B85E4",
          bcColor: "#EAF3FC",
        }
      }
    },
    urgencyStatusFn(urgencyStatus) {
      if (urgencyStatus === "0") {
        return {
          text: "非常紧急",
          color: "#F56C6C",
          bgColor: "#faeded",
        }
      } else if (urgencyStatus === "1") {
        return {
          text: "紧急",
          color: "#FF9900",
          bgColor: "#fff5e6",
        }
      } else {
        return {
          text: "正常",
          color: "#2B85E4",
          bcColor: "#EAF3FC",
        }
      }
    },
    // 选择任务开始 => 开始时间
    confirmCreatedStartTime(date) {
      this.createEndMinDate = date
      this.dropdownObj.startPlanStartTime = moment(date)
        .startOf("day")
        .format("YYYY-MM-DD")
      this.dropdownObj.endPlanStartTime = "" // 切换开始时间后直接置空结束时间重新选择
      this.createdTimeBeginVisible = false
      this.createdTimeEndVisible = true
      this.createdTimeRead = moment(date).format("YYYY-MM-DD")
    },
    // 取消任务开始 => 开始时间
    cancelCreatedStartTime() {
      this.dropdownObj.startPlanStartTime = ""
      this.dropdownObj.endPlanStartTime = ""
      this.createdTimeRead = ""
      this.minDate = new Date()
      this.searchQuery(this.dropdownObj)
      this.createdTimeBeginVisible = false
    },
    // 选择任务结束 => 开始时间
    confirmCreatedEndTime(date) {
      this.dropdownObj.endPlanStartTime = moment(date)
        .endOf("day")
        .format("YYYY-MM-DD")
      this.createdTimeEndVisible = false
      this.createdTimeRead = this.createdTimeRead + "~" + moment(date).format("YYYY-MM-DD")
      this.searchQuery(this.dropdownObj)
    },
    // 取消任务结束 => 结束时间
    cancelCreatedEndTime() {
      this.dropdownObj.startPlanStartTime = ""
      this.dropdownObj.endPlanStartTime = ""
      this.createdTimeRead = ""
      this.minDate = new Date()
      let searchObj = {
        ...this.dropdownObj,
        keyword: this.keyword,
      }
      this.searchQuery(searchObj)
      this.createdTimeEndVisible = false
    },
    // 选择任务结束 => 开始时间
    confirmCreatedStartTime2(date) {
      this.createEndMinDate2 = date
      this.dropdownObj.startPlanEndTime = moment(date)
        .startOf("day")
        .format("YYYY-MM-DD")
      this.dropdownObj.endPlanEndTime = "" // 切换开始时间后直接置空结束时间重新选择
      this.createdTimeBeginVisible2 = false
      this.createdTimeEndVisible2 = true
      this.createdTimeRead2 = moment(date).format("YYYY-MM-DD")
    },
    // 取消任务结束 => 开始时间
    cancelCreatedStartTime2() {
      this.dropdownObj.startPlanEndTime = ""
      this.dropdownObj.endPlanEndTime = ""
      this.createdTimeRead2 = ""
      this.minDate2 = new Date()

      let searchObj = {
        ...this.dropdownObj,
        keyword: this.keyword,
      }
      this.searchQuery(searchObj)
      this.createdTimeBeginVisible2 = false
    },
    // 选择任务结束 => 开始时间
    confirmCreatedEndTime2(date) {
      this.dropdownObj.endPlanEndTime = moment(date)
        .endOf("day")
        .format("YYYY-MM-DD")
      this.createdTimeEndVisible2 = false
      this.createdTimeRead2 = this.createdTimeRead2 + "~" + moment(date).format("YYYY-MM-DD")
      let searchObj = {
        ...this.dropdownObj,
        keyword: this.keyword,
      }
      this.searchQuery(searchObj)
    },
    // 取消任务结束 => 结束时间
    cancelCreatedEndTime2() {
      this.dropdownObj.startPlanEndTime = ""
      this.dropdownObj.endPlanEndTime = ""
      this.createdTimeRead2 = ""
      this.minDate2 = new Date()
      let searchObj = {
        ...this.dropdownObj,
        keyword: this.keyword,
      }
      this.searchQuery(searchObj)
      this.createdTimeEndVisible2 = false
    },
    dropDownChang() {
      this.searchQuery(this.dropdownObj)
    },
    onSearch(v) {
      this.keyword = v
      let searchObj = {
        ...this.dropdownObj,
        keyword: this.keyword,
      }
      this.searchQuery(searchObj)
    },
    onScreen() {
      this.appTitle = "更多筛选"
      this.keyword = this.$refs.topSearch.value
      let pramsObj = JSON.parse(JSON.stringify(this.dropdownObj))
      pramsObj.keyword = this.keyword
      this.$refs.SearchTag.showModal(this.keyword, pramsObj)
    },
    getCategory(sureObj) {
      this.appTitle = this.$route.query.navTitle
      this.keyword = sureObj.keyword
      this.$refs.topSearch.value = sureObj.keyword
      this.selectValue = sureObj.processId

      this.dropdownObj = JSON.parse(JSON.stringify(sureObj))
      delete this.dropdownObj.keyword
      this.selectTwoValue = this.dropdownObj.orderStatuss
      this.searchQuery(sureObj)
    },
    // 加载列表
    getList() {
      this.$refs.pageList.onLoad(1)
    },

    // 重置
    searchReset() {
      this.$refs.pageList.searchReset()
    },
    goSearch() {
      this.$router.push({ path: "/carRoomPlaneSearch" })
    },
  },
  beforeRouteLeave(to, from, next) {
    if (this.$refs.SearchTag.showSearchTag) {
      this.appTitle = this.$route.query.navTitle
      this.$refs.SearchTag.showSearchTag = false
      next(false)
    } else if (this.checkedShow) {
      this.checkedShow = false
      next(false)
    } else {
      next()
    }
  },
  created() {
    this.currentEnvironment = localStorage.getItem("currentEnvironment")
    this.appTitle = this.$route.query.navTitle
  },
  mounted() {
    let searchObj = {
      ...this.dropdownObj,
      orderStatuss: this.dropdownObj.orderStatuss ? this.dropdownObj.orderStatuss.join(",") : "",
      keyword: this.keyword,
    }
    this.searchQuery(searchObj)
  },
}
</script>

<style lang="scss" scoped>
.topSearchPading {
  padding-top: 20px;
}

.rightText-m-l {
  margin-left: 20px;
}

.search-top-flex {
  display: flex;
}

.search-top-flex-item-width1 {
  width: 20%;
}

.search-top-flex-item-width2 {
  width: 40%;
}

.currentEnvironmentTrue {
  height: calc(100vh - 200px);
}

.currentEnvironmentFalse {
  height: calc(100vh - 300px);
}

.head-slot-class {
  display: flex;
  justify-content: space-between;
}

.head-slot-div {
  display: flex;
}

.head-slot-color {
  color: #1e8df5;
}

.dialogContentBox-icon-margin {
  margin-left: 14px;
}

.dialogMessage-class {
  margin: 20px 92px 60px 92px;
  color: #888888;
}

.dialogMessage-btm-line {
  background: #f0f0f0;
  width: 100%;
  height: 2px;
}

//
.rt-column {
  padding: 20px 0 0 20px;
  //  border: 1px solid red;
}

.action-item {
  height: 80px;
  padding: 20px;
  border-top: 2px solid #eee;
}

.rt-row {
  margin-bottom: 20px;

  .column {
    width: 100%;
    display: flex;

    .column-t {
      font-size: 28px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #888888;
      // margin-bottom: 0.03rem;
    }

    .column-c {
      flex: 1;
      font-size: 28px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #191f25;
      /* （超出限定的宽度就隐藏内容) */
      overflow: hidden;
      /* （设置文字在一行显示不能换行） */
      white-space: nowrap;
      /* （规定当文本溢出时显示省略符） */
      text-overflow: ellipsis;
    }
  }
}

.room-content {
  height: 100vh;
  overflow-y: scroll;

  .serach {
    height: 66px;
    background: #f2f2f6;
    border-radius: 0;
    margin-bottom: 32px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    line-height: 66px;
    padding: 20px 24px;

    // border: 1px solid red;
    .placeh {
      font-size: 32px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #888888;
      line-height: 46px;
    }

    .icon {
      width: 30px;
      height: 32px;
    }
  }

  .serach-content {
    // height: 1.52rem;
    background: #ffffff;
    padding: 0 32px 32px 32px;

    .content {
      display: flex;

      .tapbtn {
        // height: 0.23rem;
        // background: #1890ff;
        background: #f2f2f6;
        border-radius: 4px;
        font-size: 32px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #888888;
        line-height: 46px;
        margin-right: 24px;
        text-align: center;
        padding: 8px 56px;
        cursor: pointer;
      }

      .active {
        color: #ffffff;
        background: #1890ff;
      }
    }
  }
}

.labelBox {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-left: 20px;

  .allLeft {
    display: flex;
    justify-content: center;

    .labelLeft {
      display: flex;
      justify-content: center;
      align-items: center;
      background: #f0f6fe;
      border-radius: 8px;
      box-sizing: border-box;
      padding: 6px 20px;
      margin-right: 10px;
      font-size: 22px;
    }
  }

  .allRight {
    display: block;
    float: right;
    margin-right: 5px;
    font-size: 27px;
    color: #2b85e4;
  }
}

.listBox {
  height: calc(100vh - 300px);
  overflow-y: auto;

  .icon {
    width: 6px;
    height: 32px;
    background: #1890ff;
    margin-top: 6px;
    margin-right: 20px;
  }

  .title {
    width: 580px;
    margin-right: 20px;
    // height: 0.16rem;
    font-size: 32px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #191f25;
    // line-height: 0.23rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.dialogContentBox {
  text-align: left;
  margin: 20px 38px;
  color: #191f25;
  font-size: 32px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.more-toolbar {
  width: 60px;
  height: 60px;
}

.search-bottoms {
  width: 100%;
  height: 100px;
  background: #ffffff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  bottom: 0px;
  padding: 0 22px;
  box-sizing: border-box;
  font-size: 32px;
  font-weight: 500;
  z-index: 9;

  .btncancel {
    flex: 1;
    background: #f6f6f6;
    border: 2px solid rgba(25, 31, 37, 0.12);
    box-sizing: border-box;
    height: 78px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 6px;
    margin-right: 22px;
    color: #191f25;
  }

  .btnconfirm {
    flex: 1;
    background: #1890ff;
    box-sizing: border-box;
    height: 79px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 6px;
    color: #ffffff;
  }
}

/deep/ .van-dropdown-menu__bar {
  box-shadow: none;
}
</style>
